import { c as _c } from "react/compiler-runtime";
import { LabelWithHelp } from "@components/common/label-with-help";
import { Autocomplete, NO_TRANSLATE_CLASS } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
/** Placeholder for workspaces where only email addresses can be entered. */
export const EMAILS_ONLY_PLACEHOLDER = "Enter email addresses (Separated by comma, semicolon, or space)";

/**
 * Renders autocomplete component of flat-ui for members selection. It can be used to select multiple members or emails.
 */
export function MembersAutocomplete(t0) {
  const $ = _c(23);
  const {
    label,
    isValid,
    options,
    helperText,
    isRequired,
    hasAutoFocus,
    onInputChange,
    selectedOptions,
    handleMemberSelect,
    placeHolder,
    getChipColor,
    isDisabled: t1,
    labelHelp: t2
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  const labelHelp = t2 === undefined ? "To add multiple members/emails, simply separate them by pressing enter, semicolon, or comma." : t2;
  const {
    canUseTeams
  } = useHasUserValidFeatureCompanyLevel();
  const defaultPlaceHolder = canUseTeams ? `Select ${TEAM_DISPLAY_NAME} or ${EMAILS_ONLY_PLACEHOLDER}` : EMAILS_ONLY_PLACEHOLDER;
  let t3;
  if ($[0] !== isRequired || $[1] !== label || $[2] !== labelHelp) {
    t3 = label && <LabelWithHelp isRequired={isRequired} title={label} help={labelHelp} />;
    $[0] = isRequired;
    $[1] = label;
    $[2] = labelHelp;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isDisabled) {
    t4 = {
      opacity: theme => isDisabled ? theme.palette.action.disabledOpacity : 1
    };
    $[4] = isDisabled;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = placeHolder ?? defaultPlaceHolder;
  let t6;
  if ($[6] !== getChipColor || $[7] !== handleMemberSelect || $[8] !== hasAutoFocus || $[9] !== helperText || $[10] !== isValid || $[11] !== onInputChange || $[12] !== options || $[13] !== selectedOptions || $[14] !== t5) {
    t6 = <Autocomplete allowDuplicateOnPaste={true} isValid={isValid} options={options} hasAutoFocus={hasAutoFocus} selectedOptions={selectedOptions} autocompleteHelperText={helperText} handleChange={handleMemberSelect} onInputChange={onInputChange} placeHolder={t5} getChipColor={getChipColor} />;
    $[6] = getChipColor;
    $[7] = handleMemberSelect;
    $[8] = hasAutoFocus;
    $[9] = helperText;
    $[10] = isValid;
    $[11] = onInputChange;
    $[12] = options;
    $[13] = selectedOptions;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isDisabled || $[17] !== t4 || $[18] !== t6) {
    t7 = <Stack className={NO_TRANSLATE_CLASS} inert={isDisabled} sx={t4}>{t6}</Stack>;
    $[16] = isDisabled;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t7) {
    t8 = <>{t3}{t7}</>;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}